import { z } from 'zod';

import { EliteLoanExtensionFeesInput } from '../events/CreateLoanExtensionFeesDocumentEvent';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateLoanExtensionFeesDocumentSideEffectContext = BaseLoanIdSideEffect.extend({
  input: EliteLoanExtensionFeesInput,
});
export const GenerateLoanExtensionFeesDocumentSideEffect = GenerateLoanExtensionFeesDocumentSideEffectContext.extend({
  type: z.literal('generateLoanExtensionFeesDocument'),
});
export type GenerateLoanExtensionFeesDocumentSideEffect = z.infer<typeof GenerateLoanExtensionFeesDocumentSideEffect>;
